const FILTER_KEYS = {
  INTEGRATION_IDS: 'integrationIds',
  WRITEKEYS: 'writekeys',
  EVENT_IDS: 'eventIds',
  EVENT_NAMES: 'eventNames',
  STATUSES: 'statuses',
};

export default FILTER_KEYS;
